export const colors = {
  primaryBlack: '#4C4C4C',
  'so-black-0.04': '#F5F5F5',
  'so-black-0.08': '#EBEBEB',
  'so-black-0.12': '#E0E0E0',
  'so-black-0.16': '#D6D6D6',
  'so-black-0.24': '#C2C2C2',
  'so-black-0.32': '#ADADAD',
  'so-black-0.48': '#858585',
  'so-black-0.52': '',
  'so-black-0.8': '#333333',
  'tr-black-0.04': 'rgba(76, 76, 76, 0.04)',
  'tr-black-0.08': 'rgba(76, 76, 76, 0.08)',
  'tr-black-0.12': 'rgba(76, 76, 76, 0.12)',
  'tr-black-0.16': 'rgba(76, 76, 76, 0.16)',
  'tr-black-0.24': 'rgba(76, 76, 76, 0.24)',
  'tr-black-0.32': 'rgba(76, 76, 76, 0.32)',
  'tr-black-0.48': 'rgba(76, 76, 76, 0.48)',
  'tr-black-0.80': 'rgba(76, 76, 76, 0.80)',
  actionHover: '#0065D2',
  primaryBlue: '#007BFF',
  'so-blue-0.04': '#F5FAFF',
  'so-blue-0.08': '#EBF4FF',
  'so-blue-0.12': '#E0EFFF',
  'so-blue-0.16': '#007BFF',
  'so-blue-0.24': '#C2DFFF',
  'so-blue-0.32': '#ADD5FF',
  'so-blue-0.48': '#85C0FF',
  'so-blue-0.8': '#3395FF',
  'so-blue-0.9': '#3395FF',
  'tr-blue-0.04': 'rgba(0, 123, 255, 0.04)',
  'tr-blue-0.08': 'rgba(0, 123, 255, 0.08)',
  'tr-blue-0.12': 'rgba(0, 123, 255, 0.12)',
  'tr-blue-0.16': 'rgba(0, 123, 255, 0.16)',
  'tr-blue-0.24': 'rgba(0, 123, 255, 0.24)',
  'tr-blue-0.32': 'rgba(0, 123, 255, 0.32)',
  'tr-blue-0.48': 'rgba(0, 123, 255, 0.48)',
  'tr-blue-0.72': 'rgba(0, 123, 255, 0.72)',
  'tr-blue-0.80': 'rgba(0, 123, 255, 0.80)',
  heavyBlue: '#15152B',
  primaryRed: '#FF3838',
  'red-0.04': '#FFF7F7',
  'red-0.08': '#FFEFEF',
  'red-0.12': '#FFE7E7',
  'red-0.16': '#FFDFDF',
  'red-0.24': '#FFCFCF',
  'red-0.32': '#FFBFBF',
  'red-0.48': '#FF9F9F',
  'red-0.8': '#FF6060',
  'tr-red-0.04': 'rgba(255, 56, 56, 0.04)',
  'tr-red-0.08': 'rgba(255, 56, 56, 0.08)',
  'tr-red-0.12': 'rgba(255, 56, 56, 0.12)',
  'tr-red-0.16': 'rgba(255, 56, 56, 0.16)',
  'tr-red-0.24': 'rgba(255, 56, 56, 0.24)',
  'tr-red-0.32': 'rgba(255, 56, 56, 0.32)',
  'tr-red-0.48': 'rgba(255, 56, 56, 0.48)',
  'tr-red-0.80': 'rgba(255, 56, 56, 0.80)',
  primaryGreen: '#16D29A',
  'so-green-0.04': '#F6FDFB',
  'so-green-0.08': '#ECFBF7',
  'so-green-0.12': '#E3FAF3',
  'so-green-0.16': '#DAF8EF',
  'so-green-0.24': '#C7F4E7',
  'so-green-0.32': '#B4F1DF',
  'so-green-0.48': '#8FEACE',
  'so-green-0.8': '#44DBAE',
  'tr-green-0.04': 'rgba(22, 210, 154, 0.04)',
  'tr-green-0.08': 'rgba(22, 210, 154, 0.08)',
  'tr-green-0.12': 'rgba(22, 210, 154, 0.12)',
  'tr-green-0.16': 'rgba(22, 210, 154, 0.16)',
  'tr-green-0.24': 'rgba(22, 210, 154, 0.24)',
  'tr-green-0.32': 'rgba(22, 210, 154, 0.32)',
  'tr-green-0.48': 'rgba(22, 210, 154, 0.48)',
  'tr-green-0.80': 'rgba(22, 210, 154, 0.80)',
  primaryOrange: '#F29100',
  'so-orange-0.04': '#F5F5F5',
  'so-orange-0.08': '#EBEBEB',
  'so-orange-0.12': '#FDF2E0',
  'so-orange-0.16': '#D6D6D6',
  'so-orange-0.24': '#C2C2C2',
  'so-orange-0.32': '#ADADAD',
  'so-orange-0.48': '#858585',
  'so-orange-0.8': '#333333',
  'tr-orange-0.04': 'rgba(242, 145, 0, 0.04)',
  'tr-orange-0.08': 'rgba(242, 145, 0, 0.08)',
  'tr-orange-0.12': 'rgba(242, 145, 0, 0.12)',
  'tr-orange-0.16': 'rgba(242, 145, 0, 0.16)',
  'tr-orange-0.24': 'rgba(242, 145, 0, 0.24)',
  'tr-orange-0.32': 'rgba(242, 145, 0, 0.32)',
  'tr-orange-0.48': 'rgba(242, 145, 0, 0.48)',
  'tr-orange-0.80': 'rgba(242, 145, 0, 0.80)',
  primaryYellow: '#F29100',
  'so-yellow-0.04': '#FFFBF5',
  'so-yellow-0.08': '#FFF7EB',
  'so-yellow-0.12': '#FEF3E2',
  'tr-white-0.72': 'rgba(255, 255, 255, 0.72)',
  primaryWhite: '#fff',
  transparent: 'transparent',
};
